var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogicComponentsLibrary01 = function SvgLogicComponentsLibrary01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logic_components_library-01_svg2__a",
    x1: 0.05,
    x2: 199.95,
    y1: 100.11,
    y2: 100.11,
    gradientTransform: "matrix(1 0 0 -1 0 200.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M157.75 105.9c2.6 9 10.9 15.7 20.7 15.7s21.5-9.7 21.5-21.5-9.7-21.5-21.5-21.5-18.2 6.6-20.7 15.7h-39.3V71.5h9.8c1.8 0 3.6-.9 4.7-2.3l17.1-22.8h7.7c2.6 9 10.9 15.7 20.7 15.7s21.5-9.7 21.5-21.5-9.7-21.5-21.5-21.5-18.2 6.6-20.7 15.7h-10.6c-1.8 0-3.6.9-4.7 2.3l-17.1 22.8h-6.9v-54c0-3.2-2.6-5.9-5.9-5.9h-25.1c-3 0-5.4 2.2-5.8 5.1l-2 16.3c-7.3 1.9-14.2 4.8-20.7 8.6l-13-10.1c-2.3-1.8-5.7-1.6-7.7.5l-17.8 17.8c-2.1 2.1-2.3 5.4-.5 7.7l10.1 13c-3.8 6.5-6.7 13.4-8.6 20.7l-16.3 2c-2.9.4-5.1 2.9-5.1 5.8v25.1c0 3 2.2 5.5 5.1 5.9l16.3 2c1.9 7.3 4.8 14.2 8.6 20.7l-10.1 13c-1.8 2.3-1.6 5.7.5 7.7l17.8 17.8c2.1 2.1 5.4 2.3 7.7.5l13-10.1c6.5 3.8 13.4 6.7 20.7 8.6l2 16.3c.4 2.9 2.9 5.1 5.8 5.1h25.1c3.2 0 5.9-2.6 5.9-5.9v-53.8h6.9l17.1 22.8c1.1 1.5 2.8 2.3 4.7 2.3h10.6c2.6 9 10.9 15.7 20.7 15.7s21.5-9.7 21.5-21.5-9.7-21.5-21.5-21.5-18.2 6.6-20.7 15.7h-7.7l-17.1-22.8c-1.1-1.5-2.8-2.3-4.7-2.3h-9.8v-22.8zm20.8-15.7c5.4 0 9.8 4.4 9.8 9.8s-4.4 9.8-9.8 9.8-9.8-4.4-9.8-9.8 4.4-9.8 9.8-9.8m0-59.7c5.4 0 9.8 4.4 9.8 9.8s-4.4 9.8-9.8 9.8-9.8-4.4-9.8-9.8 4.4-9.8 9.8-9.8m0 119.3c5.4 0 9.8 4.4 9.8 9.8s-4.4 9.8-9.8 9.8-9.8-4.4-9.8-9.8 4.4-9.8 9.8-9.8m-71.8-9.2v.1c-2.2.4-4.4.5-6.7.5-22.7 0-41.2-18.5-41.2-41.2s24.86-41.2 47.56-41.2M92.65 188.3l-1.9-15.2c-.3-2.5-2.2-4.5-4.6-5a69.3 69.3 0 0 1-24.3-10.1c-2.1-1.4-4.8-1.3-6.8.3l-12.1 9.4-10.4-10.4 9.4-12.1c1.5-2 1.6-4.7.3-6.8a69.3 69.3 0 0 1-10.1-24.3c-.5-2.5-2.5-4.3-5-4.6l-15.2-1.9V92.8l15.2-1.9c2.5-.3 4.5-2.2 5-4.6A69.3 69.3 0 0 1 42.25 62c1.4-2.1 1.3-4.8-.3-6.8l-9.4-12.1 10.4-10.4 12.1 9.4c2 1.5 4.7 1.6 6.8.3a69.3 69.3 0 0 1 24.3-10.1c2.5-.5 4.3-2.5 4.6-5l1.9-15.2h14.1l.27 35.53c-2.2-.3-4.67-.13-6.97-.13-29.2 0-52.9 23.7-52.9 52.9s23.7 52.9 52.9 52.9 4.5-.1 6.7-.4v35.8h-14.1z",
    style: {
      fill: "url(#logic_components_library-01_svg2__a)"
    }
  }));
};
export default SvgLogicComponentsLibrary01;